<template>
  <Carousel
    class="carousel"
    :autoplay="true"
    :autoplayTimeout="5000"
    :autoplayHoverPause="true"
    :perPage="1"
    :navigationEnabled="true"
    :loop="true"
    :speed="500"
    :duration="5000"
  >
    <Slide class="slide" v-for="(item, i) in items" :key="i">
      <img :src="item.src" :alt="item.src" />
    </Slide>
  </Carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  props: ["items"],
  components: {
    Carousel,
    Slide
  },
  data() {
    return {
      options: {
        autoplay: true
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.carousel {
}
.slide {
  height: 100%;
}
img {
  width: 100%;
}

.VueCarousel-dot {
  margin-top: 0 !important;
}
.VueCarousel-dot--active {
  background-color: #b8c2d6 !important;
}
</style>